<template>
  <div>
    <md-dialog style="-moz-box-orient: unset; min-width: 65%;" :md-active.sync="modalSwitch">
      <md-dialog-title>Contar história {{ place && "- " + place.name }}</md-dialog-title>
      <md-dialog-content>
        <create-form
          :place="place"
          :oldChapter="chapter"
          :showMinimap="showMinimap"
          @newPlace="newPlace = $event"
          @newChapter="newChapter = $event"
        />
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          style="background: lightgrey; margin-right: 15px;"
          @click="modalSwitch = false"
        >Cancelar</md-button>
        <submit :chapter="newChapter" :place="place || newPlace" :mode="mode" />
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import createForm from "@/components/content/create/form";
import submit from "@/components/content/create/submit";

export default {
  name: "CreateChapterDialog",
  props: ["createOn", "chapter", "place", "showMinimap", "mode"],
  components: {
    createForm,
    submit
  },
  data() {
    return {
      newPlace: null,
      newChapter: null,
    }
  },
  computed: {
    modalSwitch: {
      get() {
        return this.createOn;
      },
      set(off) {
        this.$emit("close", off);
      }
    }
  },
};
</script>
